import world1 from '../images/world/QA1A5097.jpg'
import world2 from '../images/world/QA1A4952.jpg'
import world3 from '../images/world/QA1A4672.jpg'
import world4 from '../images/world/EV2A4660.jpg'
import world5 from '../images/world/EV2A4842.jpg'
import world6 from '../images/world/QA1A1112.jpg'
import world7 from '../images/world/QA1A6764.jpg'
import world8 from '../images/world/QA1A8215.jpg'

export const worldData = [
  {
    id: 1,
    image: world1,
    alignment: 'horizontal',
    alt: 'world image 1 Jari Sokka'
  },
  {
    id: 2,
    image: world2,
    alignment: 'horizontal',
    alt: 'world image 2 Jari Sokka'
  },
  {
    id: 3,
    image: world3,
    alignment: 'horizontal',
    alt: 'world image 3 Jari Sokka'
  },
  {
    id: 4,
    image: world4,
    alignment: 'vertical',
    alt: 'world image 4 Jari Sokka'
  },
  {
    id: 5,
    image: world5,
    alignment: 'horizontal',
    alt: 'world image 5 Jari Sokka'
  },
  {
    id: 6,
    image: world6,
    alignment: 'horizontal',
    alt: 'world image 6 Jari Sokka'
  },
  {
    id: 7,
    image: world7,
    alignment: 'horizontal',
    alt: 'world image 7 Jari Sokka'
  },
  {
    id: 8,
    image: world8,
    alignment: 'horizontal',
    alt: 'world image 8 Jari Sokka'
  }
]